import React, { useEffect, useMemo, useRef } from 'react'
import get from 'lodash/get'
import WithPopup from '../withPopup/withPopup'
import { DropdownProps } from './Dropdown.types'
import InputWrapper from '../InputWrapper/InputWrapper'
import InputList from '../InputList/InputList'
import InputPlaceholder from '../helpers/InputPlaceholder'
import Icon from '../../Icon/Icon'
import useInput from '../useInput'
import Visible from '../../Visible/Visible'
import Select from 'react-select'

const Dropdown: React.FC<DropdownProps> = ({
    dataItemTemplate,
    placeholder = 'Select',
    noNullOption = false,
    prelabel,
    ...restProps
}) => {
    const {
        labelStyle,
        autoFocus,
        showPopupOnMount,
        textField,
        valueField,
        showFilter,
        icon,
        popupWidth,
        displayValue,
        isDisabled,
        displayItemTemplate,
        isListItemDisabledKey,
        isListItemDisabledMessageKey,
    } = restProps
    const context = useInput({ ...restProps }, 'any')
    const { value, data, onChange, onFocus, onBlur } = context
    const preLabelRef = useRef(null)

    const getDataItem = () => {
        let dataItem = value
        if (data && valueField) {
            dataItem = data.find((d) => {
                return get(d, valueField) === value
            })
        }
        return dataItem
    }

    const renderValue = () => {
        const dataItem = getDataItem()

        if (!dataItem) {
            return ''
        }

        return textField ? get(dataItem, textField) : dataItem
    }

    const renderDisplay = () => {
        if (labelStyle !== 'merged' && (value === null || value === undefined || value === ''))
            return <InputPlaceholder placeholder={placeholder} />

        if (displayItemTemplate) {
            return displayItemTemplate({ value, data, dataItem: getDataItem(), textField, valueField })
        }

        if (displayValue) {
            return displayValue(value)
        }
        return (
            <span style={{ display: 'flex', alignItems: 'center' }}>
                {/*{icon ? <Icon type={icon} /> : ''}*/}
                {renderValue()}
            </span>
        )
    }

    const handleChange = (dataItem) => {
        let { value } = dataItem
        // if (value !== null && valueField) {
        //     value = get(dataItem, valueField)
        // }

        onChange(value, dataItem)
    }

    const preLabelWidth = useMemo(() => {
        if (preLabelRef.current) {
            return preLabelRef?.current.getBoundingClientRect()?.width
        }
        return 0
    }, [preLabelRef.current])

    const selectOptions = useMemo(() => {
        const d = data.map((d) => {
            if (displayItemTemplate) {
                return {
                    value: d,
                    label: displayItemTemplate({ data, dataItem: d, textField, valueField, value }),
                    isDisabled: d.isDisabled || false,
                }
            }
            if (!textField) {
                return {
                    value: d,
                    label: d,
                    isDisabled: d.isDisabled || false,
                }
            }
            return {
                value: d[valueField],
                label: d[textField],
                isDisabled: d.isDisabled || false,
            }
        })
        return [
            {
                value: null,
                label: 'Select',
            },
            ...d,
        ]
    }, [data])

    const getValItem = useMemo(() => {
        return selectOptions.find((s) => s.value === value)
    }, [selectOptions, value])

    return (
        <InputWrapper {...context} inputType={'dropdown'}>
            <Select
                autoFocus={autoFocus}
                onChange={handleChange}
                name={name}
                menuPortalTarget={document.body}
                className='basic-single'
                classNamePrefix='select'
                defaultValue={getValItem}
                options={selectOptions}
                isClearable
                isSearchable={showFilter}
                isDisabled={isDisabled}
                styles={{
                    control: (baseStyles, state) => ({
                        ...baseStyles,
                        minHeight: '30px',
                        border: '1px solid #dedfe0',
                        boxShadow: state.isFocused ? '0 0 0 1px #a03b84' : null,
                        borderColor: state.isFocused ? '#6e0050' : null,
                        ':hover': { borderColor: '#6e0050' },
                    }),
                    indicatorsContainer: (baseStyles, state) => ({
                        ...baseStyles,
                        display: 'none',
                        padding: '0px',
                    }),
                    input: (baseStyles, state) => ({
                        ...baseStyles,
                        fontSize: '12px',
                    }),
                    placeholder: (baseStyles, state) => ({
                        ...baseStyles,
                        fontSize: '12px',
                    }),
                    singleValue: (baseStyles, state) => ({
                        ...baseStyles,
                        fontSize: '10pt',
                        fontWeight: 500,
                    }),
                    menu: (baseStyles, state) => ({
                        ...baseStyles,
                        zIndex: 99999,
                    }),
                    menuPortal: (baseStyles, state) => ({
                        ...baseStyles,
                        zIndex: 99999,
                    }),
                    option: (baseStyles, state) => {
                        return {
                            ...baseStyles,
                            fontSize: '10pt',
                            color: state.isSelected ? '#6e0050' : '#6e0050',
                            background: state.isSelected || state.isFocused ? '#fad8f1' : '#fff',
                            ':hover': { background: '#fbecf7' },
                            ':focus': { background: '#fad8f1' },
                        }
                    },
                }}
            />
            {/*<WithPopup*/}
            {/*    maxHeight={null}*/}
            {/*    showPopupOnMount={showPopupOnMount}*/}
            {/*    width={popupWidth}*/}
            {/*    onShow={() => {*/}
            {/*        onFocus()*/}
            {/*    }}*/}
            {/*    onClose={() => {*/}
            {/*        onBlur()*/}
            {/*    }}*/}
            {/*    content={({ openPopup }) => (*/}
            {/*        <InputList*/}
            {/*            dataItemTemplate={dataItemTemplate}*/}
            {/*            closeOnItemClick*/}
            {/*            setPopupShow={openPopup}*/}
            {/*            showFilter={showFilter}*/}
            {/*            placeholder={placeholder}*/}
            {/*            data={data}*/}
            {/*            value={value}*/}
            {/*            textField={textField}*/}
            {/*            noNullOption={noNullOption}*/}
            {/*            isDisabledKey={isListItemDisabledKey}*/}
            {/*            isDisabledMessageKey={isListItemDisabledMessageKey}*/}
            {/*            onChange={handleChange}*/}
            {/*        />*/}
            {/*    )}*/}
            {/*>*/}
            {/*    {(popupContext) => (*/}
            {/*        <div*/}
            {/*            data-testid='Dropdown'*/}
            {/*            className={'r-dropdown r-input-base'}*/}
            {/*            ref={popupContext.anchor}*/}
            {/*            onClick={(e) => {*/}
            {/*                if (!isDisabled) {*/}
            {/*                    popupContext.openPopup()*/}
            {/*                }*/}
            {/*            }}*/}
            {/*        >*/}
            {/*            <Visible visible={!!prelabel}>*/}
            {/*                <div ref={preLabelRef} className={'r-input-pre-label'}>*/}
            {/*                    {prelabel}*/}
            {/*                </div>*/}
            {/*            </Visible>*/}
            {/*            <div style={{ paddingLeft: preLabelWidth + 'px' }} className={'r-input-display-value'}>*/}
            {/*                {renderDisplay()} <Icon fontSize={'7pt'} type={'chevron-down'} />*/}
            {/*            </div>*/}
            {/*            <select*/}
            {/*                onFocus={() => {*/}
            {/*                    if (!isDisabled) {*/}
            {/*                        popupContext.openPopup()*/}
            {/*                        onFocus()*/}
            {/*                    }*/}
            {/*                }}*/}
            {/*            />*/}
            {/*        </div>*/}
            {/*    )}*/}
            {/*</WithPopup>*/}
        </InputWrapper>
    )
}

export default Dropdown
